// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___TEvt","title":"styles_title__3oxYP"};